import { useEffect, useState } from "react";
import { callHistoryForDashboard } from "../store/api/CustomerApi";
import { Card, Col, Row } from "react-bootstrap";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis } from "recharts";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";

export default function CallDashboard() {
    const [callCount, getCallCount] = useState([]);
    const colorPalet = ["#053331", "#32a89a", "#a83257", "#325da8", "#7332a8", "#e0a122", "#91a8c2", "#07274a", "#4a0725", "#32a852","blue","orange","red",
        "#2284e0ff","#e022aaff","#404199ff"]
    const callStatuss = { Answered: "پاسخ داده شده", Called: "تماس گرفته شده", Missed: "از دست رفته", NoAnswer: "بدون پاسخ" }
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </>
        );
    }
    const renderDateLegend = (props) => {
        const { payload } = props;

        return (
            <>
                {
                    payload.reverse().map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{callStatuss[entry.value] ?? entry.value}&nbsp;&nbsp;
                        </span>
                    ))
                }
            </>
        );
    }
    // const uniqueColorForDataBar = (array, propName) => {
    //     array = array.map((item)=>Object.keys(item.Data).forEach(key => item[key] = item.Data[key]));

    //     return result;

    // }
    useEffect(() => {
        callHistoryForDashboard(getCallCount);
        document.body.classList = "notMain";
        document.Title = "بی همتا-مشتریان";
    }, []);
    useEffect(() => {
        callCount?.Data?.byUserAndDate?.forEach?.((item) => item.Data.forEach((data) => item[data.Date] = data.Count));
        callCount?.Data?.byDateAndStatus?.forEach?.((item) => { item.PTitle = callStatuss[item.Title]; item.Data.forEach((data) => item[data.Date] = data.Count); });
        callCount?.Data?.byUserAndStatus?.forEach?.((item) => item.Data.forEach((data) => item[data.DataTitle] = data.Count));
        callCount?.Data?.byUserAndCallType?.forEach((item) => item.Data.forEach((data) => item[data.DataTitle] = data.Count));

    }, [callCount])

    return (

        <div className="container-fluid mt-1">
            <br />
            <Card className="card">
                <Card.Header className="headerStyle"><FontAwesomeIcon icon={faChartBar} size="lg"/>&nbsp;داشبورد تماس ها</Card.Header>
                <Card.Body className="bodyStyle" >
                    {
                        callCount === "PENDING" ?
                            <Loader type="BallTriangle" width={50} height={50} className="loader" color="#bb1370" />
                            :
                            <Row>
                                <Col md={12}>
                                    <Card className="newCard" style={{ "--mainColor": "#0f5999f9", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                                &nbsp;
                                                <span className="cardTitle">تماس های 7 روز گذشته<span style={{ fontSize: "1rem" }}>(به تفکیک کاربر و روز)</span></span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.byUserAndDate) && callCount.Data.byUserAndDate.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.byUserAndDate} className="barChart">
                                                        <Legend align="center" content={renderDateLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="UserName" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        {callCount?.Data?.byUserAndDate[0].Data.map((data, i) => <Bar dataKey={data.Date} fill={colorPalet[i]} label={{ position: 'top' }} isAnimationActive={false} key={i} />)}

                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>
                                <Col md={12} className="mt-2">
                                    <Card className="newCard" style={{ "--mainColor": "#0f8d99f9", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                                &nbsp;
                                                <span className="cardTitle">تماس های 7 روز گذشته<span style={{ fontSize: "1rem" }}>(تعداد تماس ها به تفکیک روز و وضعیت)</span></span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.byDateAndStatus) && callCount.Data.byDateAndStatus.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.byDateAndStatus} className="barChart">
                                                        <Legend align="center" content={renderDateLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="PTitle" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        {callCount?.Data?.byDateAndStatus[0].Data.map((data, i) =>
                                                            <Bar dataKey={data.Date} fill={colorPalet[i]} label={{ position: 'top' }} isAnimationActive={false} key={i} />)
                                                        }
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>
                                <Col md={12} className="mt-2">
                                    <Card className="newCard" style={{ "--mainColor": "#280f99f9", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                                &nbsp;
                                                <span className="cardTitle">تماس های 7 روز گذشته<span style={{ fontSize: "1rem" }}>(تعداد تماس ها به تفکیک کاربر و وضعیت)</span></span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.byUserAndStatus) && callCount.Data.byUserAndStatus.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.byUserAndStatus} className="barChart">
                                                        <Legend align="center" content={renderDateLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="UserName" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        {callCount.Data.byUserAndStatus[0].Data.map((data, i) =>
                                                            <Bar dataKey={data.DataTitle} fill={colorPalet[i]} label={{ position: 'top' }} isAnimationActive={false} key={i} />)
                                                        }
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>
                                <Col md={7} className="mt-2">
                                    <Card className="newCard" style={{ "--mainColor": "#0f7b99f9", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                                &nbsp;
                                                <span className="cardTitle">تماس های 7 روز گذشته<span style={{ fontSize: "1rem" }}>(تعداد تماس ها به تفکیک نوع تماس و کابر)</span></span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.byUserAndCallType) && callCount.Data.byUserAndCallType.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.byUserAndCallType} className="barChart">
                                                        <Legend align="center" content={renderDateLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="Title" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        {callCount.Data.byUserAndCallType[0].Data.map((data, i) =>
                                                            <Bar dataKey={data.DataTitle} fill={colorPalet[i]} label={{ position: 'top' }} isAnimationActive={false} key={i} />)
                                                        }
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>                                
                                <Col md={5} className="mt-2">
                                    <Card className="newCard" style={{ "--mainColor": "#f64600e6", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg" />
                                                &nbsp;
                                                <span className="cardTitle">تماس ها به تفکیک ماه</span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.perMonth) && callCount.Data.perMonth.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.perMonth} className="barChart">
                                                        <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        <Bar dataKey="Count" fill="#468d94" label={{ position: 'top' }} isAnimationActive={false} />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>
                            </Row>}
                </Card.Body>
            </Card>
        </div>
    )
}